export default "__VITE_ASSET__83e6f9f6__"